import { Rout } from "./rout/Rout";

function App() {
  return (<>
    <Rout/>
    </>);
}

export default App;